import React from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'

class FaqsRoofing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showItems: [
        true,
        false,
        false
      ],
    }
  }
  onClickList = (event, index) => {
    event.preventDefault()
    let showItems = this.state.showItems
    for (let i = 0; i < showItems.length; i++) {
      if (i == index) {
        showItems[i] = !showItems[i]
      } else {
        showItems[i] = false
      }
    }
    this.setState({ showItems })
  }

  render() {
    return (
      <section
        id="faqsRoofing"
        className="wrap-sec style-transitions fadeInDown wow faq-section faqRoofing-section"
      >
        <div className="w-lg-82 mr-auto w-sm-100">
          <div className="text-center">
            <h2 className="st-title ttl-mr">
              Frequently Asked{' '}
              <span className="infity-color">Questions</span>
            </h2>
            <p className="st-text">
              Have any questions? Here are the most common questions we hear
              today.
                </p>
          </div>

          <div className="row faq-tab-content">
            <div className="col-md-12">
              <div className="tab-content" id="v-pills-tabContent">
                <div className="accordion accordian-toggles accordian-mode-tgl">
                  <div className="accordian-tgl-wrap">
                    <div
                      className="accordian-tgl-title d-flex align-items-start justify-content-between"
                      onClick={event => this.onClickList(event, 0)}
                    >
                      <a href="#" className={this.state.showItems[0] ? "infity-color" : ""}>
                        What is the difference between re-roofing and
                        replacing my roof?
                              </a>
                      {this.state.showItems[0] ? (
                        <span className="ion ion-minus my-0 mr-2"></span>
                      ) : (
                          <span className="ion ion-plus my-0 mr-2"></span>
                        )}
                    </div>
                    <div
                      className="accordian-tgl"
                      style={{
                        display: this.state.showItems[0]
                          ? 'block'
                          : 'none',
                      }}
                    >
                      <div className="accordian-tgl-in">
                        <p>
                          Re-roofing is the process of recovering an
                          existing roof. Replacing is removing the
                          existing roof, repairing any damage and
                                  installing a new roof.{' '}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="accordian-tgl-wrap">
                    <div
                      className="accordian-tgl-title d-flex align-items-start justify-content-between"
                      onClick={event => this.onClickList(event, 1)}
                    >
                      <a href="#" className={this.state.showItems[1] ? "infity-color" : ""}>What is the warranty for roofing?</a>
                      {this.state.showItems[1] ? (
                        <span className="ion ion-minus my-0 mr-2"></span>
                      ) : (
                          <span className="ion ion-plus my-0 mr-2"></span>
                        )}
                    </div>
                    <div
                      className="accordian-tgl"
                      style={{
                        display: this.state.showItems[1]
                          ? 'block'
                          : 'none',
                      }}
                    >
                      <div className="accordian-tgl-in">
                        <p>
                          We offer a 50-year limited lifetime warranty
                          for your roof.
                                </p>
                      </div>
                    </div>
                  </div>

                  <div className="accordian-tgl-wrap">
                    <div
                      className="accordian-tgl-title d-flex align-items-start justify-content-between"
                      onClick={event => this.onClickList(event, 2)}
                    >
                      <a href="#" className={this.state.showItems[2] ? "infity-color" : ""}>
                        What type of shingles are the best for my roof?
                              </a>
                      {this.state.showItems[2] ? (
                        <span className="ion ion-minus my-0 mr-2"></span>
                      ) : (
                          <span className="ion ion-plus my-0 mr-2"></span>
                        )}
                    </div>
                    <div
                      className="accordian-tgl"
                      style={{
                        display: this.state.showItems[2]
                          ? 'block'
                          : 'none',
                      }}
                    >
                      <div className="accordian-tgl-in">
                        <p>
                          The type of shingles depends on a few
                          different factors – where you live, the style
                          of your roof and your budget. Whether is a
                          deciding factor on the durability of the
                          shingles. You’ll also want to pay attention to
                          how your roof is structured. Is it more like a
                          valley, or is it flat? Lastly, your budget
                          will determine the different types of
                          shingles. We offer a variety of financing
                                  options to fit your need.{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default FaqsRoofing
